import React from "react";
import { useWatchState, setState } from "@/store";
import { Modal, Table, Popconfirm, message } from "antd";
import { BaseService } from "@/service";

const App = () => {

    const [[{ title = "申请记录", show, hide, width = 800, clinic = [], userId }]] = useWatchState(["modal.clinicApplyResult"])

    const onRevoke = (id, index) => {
        BaseService.put({
            table: "thtt_clinic",
            data: {
                audit_status: 2
            },
            where: {id}
        }).then(res => {
            if (res.data.status !== 200) return message.error(res.data.msg);
            message.success("撤销成功！");
            setState(`modal.clinicApplyResult.clinic[${index}].audit_status`, 2);
        })
    }

    const columns = [
        {
            title: "企业名称",
            dataIndex: "org_name",
            key: "org_name",
        },
        {
            title: "联系人",
            dataIndex: "contacts",
            key: "contacts",
        },
        {
            title: "联系电话",
            dataIndex: "phone",
            key: "phone",
        },
        {
            title: "状态",
            dataIndex: "audit_status",
            key: "audit_status",
            render: (audit_status) => ["待处理", "已预约", "已撤销"][audit_status]
        },
        {
            title: "申请时间",
            dataIndex: "add_time",
            key: "add_time",
            render: add_time => new Date(add_time).format("yyyy-MM-dd hh:mm:ss")
        },
        {
            title: "操作",
            key: "action",
            render: (data, vo, i) => (
                <span className="child-left--small">
                    {data.audit_status !== 2 && <Popconfirm placement="top" title={"确认撤销吗？"} onConfirm={onRevoke.later(data.id, i)} okText="确认" cancelText="取消">
                        <a>撤销</a>
                    </Popconfirm>}
                </span>
            )
        }
    ];

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <Table
                className="self-top--little"
                columns={columns}
                dataSource={clinic}
                pagination={false}
            />
        </Modal>
    );
}

export default App;